// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  border-radius: 0 !important;
}

.content {
  padding: 1rem;
  margin-bottom: 1rem;
}

.field-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

.field-label {
  flex: 0 0 130px;
  margin: 0;
}

.field-value {
  flex: 1 1 auto;
  min-width: 0;
}

.general-error {
  color: var(--mat-form-field-error-text-color, #f44336);
  font-size: 0.85em;
  margin: -4px 0 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/chemicals/edit-chemical/edit-chemical.component.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AACF;;AAEA;EACE,eAAA;EACA,SAAA;AACF;;AAEA;EACE,cAAA;EACA,YAAA;AACF;;AAEA;EACE,sDAAA;EACA,iBAAA;EACA,mBAAA;AACF","sourcesContent":[":host ::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\n  border-radius: 0 !important;\n}\n\n.content {\n  padding: 1rem;\n  margin-bottom: 1rem;\n}\n\n.field-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.field-label {\n  flex: 0 0 130px;\n  margin: 0;\n}\n\n.field-value {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.general-error {\n  color: var(--mat-form-field-error-text-color, #f44336);\n  font-size: 0.85em;\n  margin: -4px 0 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
